import { render, staticRenderFns } from "./gelirgiderrapor.vue?vue&type=template&id=6c0f40da"
import script from "./gelirgiderrapor.vue?vue&type=script&lang=js"
export * from "./gelirgiderrapor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports